import { render, staticRenderFns } from "./OnRoad.vue?vue&type=template&id=19121b50&scoped=true"
import script from "./OnRoad.vue?vue&type=script&lang=js"
export * from "./OnRoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19121b50",
  null
  
)

export default component.exports